import { type PackageContextType } from "@quote/types";
import { createContext } from "react";

export const PackageContext = createContext<PackageContextType>({
  packageId: 0,
  drawerId: "",
});
